var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
var ThirdTelephoneBook = /** @class */ (function (_super) {
    __extends(ThirdTelephoneBook, _super);
    function ThirdTelephoneBook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [
            {
                source: '网查',
                relation: '好友',
                name: '苏健',
                pinyin: 'SuJian',
                telType: '手机',
                telphone: '15702944066(西安)',
                email: '744929434@qq.com',
                connect: 1,
                dial: 10,
                date: '2018-07-09',
                zuijintel: 'PTP',
            },
            {
                source: '数据魔盒',
                relation: '好友',
                name: '苏健',
                pinyin: 'SuJian',
                telType: '手机',
                telphone: '15702944066(西安)',
                email: '744929434@qq.com',
                connect: 1,
                dial: 10,
                date: '2018-07-09',
                zuijintel: 'PTP',
            },
            {
                source: '网查',
                relation: '好友',
                name: '苏健',
                pinyin: 'SuJian',
                telType: '手机',
                telphone: '15702944066(西安)',
                email: '744929434@qq.com',
                connect: 1,
                dial: 10,
                date: '2018-07-09',
                zuijintel: 'Stop',
            },
        ];
        return _this;
    }
    ThirdTelephoneBook.prototype.refreshData = function () { };
    ThirdTelephoneBook = __decorate([
        Component({
            components: {},
        })
    ], ThirdTelephoneBook);
    return ThirdTelephoneBook;
}(Vue));
export default ThirdTelephoneBook;
